//AIzaSyB-sKDtiWEkmbv_54oPrkzu-GtPuAeY7nA
import axios from "axios"
const KEY = "AIzaSyB-sKDtiWEkmbv_54oPrkzu-GtPuAeY7nA";

export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
  params: {
    part: "snippet",
    type: "video",
    maxResult: 10,
    key: KEY
  }
})